import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from './axios/axios'
import { logout } from './userSlice'

const initialState = {
  securitydepositList: [],
  securitydepositPrintList: [],
  bankData: [],
  employeeData: [],
  error: null,
  isLoading: false,
  currentPage: 0,
  totalPages: 0,
  filter: '',
}

export const getSecuritydepositList = createAsyncThunk(
  'securitydeposit/getSecuritydepositList',
  async (obj, { rejectWithValue, fulfillWithValue, getState, dispatch }) => {
    try {
      const { user } = getState()

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.user.token}`,
        },
      }
      const res = await axios.get(`/api/home/securitydeposit?${obj}`, config)

      return fulfillWithValue(res.data)
    } catch (error) {
      if (error.response.status === 401 || error.response.status === 403) {
        dispatch(logout(error.response.data))
      }
      return rejectWithValue(error.response.data)
    }
  }
)

export const getSecuritydepositPrintList = createAsyncThunk(
  'securitydeposit/getSecuritydepositPrintList',
  async (obj, { rejectWithValue, fulfillWithValue, getState, dispatch }) => {
    try {
      const { user } = getState()

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.user.token}`,
        },
      }
      const res = await axios.get(
        `/api/print/printsecuritydepositdata?${obj}`,
        config
      )

      return fulfillWithValue(res.data)
    } catch (error) {
      if (error.response.status === 401 || error.response.status === 403) {
        dispatch(logout(error.response.data))
      }
      return rejectWithValue(error.response.data)
    }
  }
)

const securitydepositSlice = createSlice({
  name: 'securitydeposit',
  initialState,
  reducers: {
    resetState: (state) => {
      state.error = ''
      state.addSuccess = false
      state.updateSuccess = false
    },
  },
  extraReducers: {
    [getSecuritydepositList.pending]: (state) => {
      state.isLoading = true
      state.error = ''
    },
    [getSecuritydepositList.fulfilled]: (state, action) => {
      state.isLoading = false
      state.securitydepositList = action.payload.items
      state.employeeData = action.payload.EmployeeData
      state.bankData = action.payload.BankData
      state.currentPage = action.payload.currentPage
      state.totalPages = action.payload.totalPages
    },
    [getSecuritydepositList.rejected]: (state, action) => {
      state.isLoading = false
      state.error = action.payload
    },
    [getSecuritydepositPrintList.fulfilled]: (state, action) => {
      state.isLoading = false
      state.securitydepositPrintList = action.payload.items
      state.filter = action.payload.Filter
    },
    [getSecuritydepositPrintList.rejected]: (state, action) => {
      state.isLoading = false
      state.error = action.payload
    },
  },
})

export default securitydepositSlice.reducer
